var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"hero-container"},[_c('div',{staticClass:"container-wrapper"},[[_c('v-sheet',{staticClass:"overflow-hidden",staticStyle:{"position":"relative"},attrs:{"height":"100vh"}})]],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }